export function useStrapiProducts() {
  const { getStrapiProducts } = useStrapiService();
  const commerceStore = useCommerceStore();
  const strapiProducts = useState("strapiProducts", () => null);

  const fetchStrapiProducts = async () => {
    if (strapiProducts.value) return strapiProducts.value;

    const result = await getStrapiProducts();
    if (result) {
      strapiProducts.value = result;
      commerceStore.updateProductsWithStrapi(result);
    }
    return result;
  };

  return {
    strapiProducts,
    fetchStrapiProducts,
  };
}
